
import Call from '../helpers/Network/Call';

import ExternalConfiguration from '../external-configuration';

const Tagging = {

  processConfiguration: (loadedConfiguration, auxiliarData) => {
    if( !loadedConfiguration.activeTagging) return null;

    const hasTattingList = loadedConfiguration.taggingList?.length;
    const { taggingList, chaptersUrl } = hasTattingList ? ({
      taggingList: loadedConfiguration.taggingList.map( ({ url, name }) => ({ url, label: name })),
      chaptersUrl: undefined,
    }) : ({
      taggingList: auxiliarData.captions,
      chaptersUrl: auxiliarData.chaptersUrl,
    });

    const taggingConfiguration = {
      taggingStyle: loadedConfiguration.taggingStyle,
      widthFactor: ExternalConfiguration.TaggingDefaults.widthFactor,
      transcriptionUrlLabel: ExternalConfiguration.TaggingDefaults.transcriptionUrlLabel,
      defaultLanguage: undefined,
      taggingList,
      chaptersUrl,
      taggings: {},
      chapters: [],
    };

    return taggingConfiguration;
  },

  onResize: taggingConfiguration => {
    return { width: window.innerWidth * taggingConfiguration.widthFactor, height: window.innerHeight };
  },

  setDefaultLanguage: (taggingConfiguration, defaultLanguage) => {    // REVIEW unificar como setFromQueryString, y/o hacer comprobacion de integridad
    taggingConfiguration.defaultLanguage = defaultLanguage;
    return taggingConfiguration;
  },

  setTaggingList: (taggingConfiguration, transcriptionUrl) => {    // REVIEW unificar como setFromQueryString, y/o hacer comprobacion de integridad
    taggingConfiguration.taggingList = [{ name: taggingConfiguration.transcriptionUrlLabel, url: transcriptionUrl }];
    return taggingConfiguration;
  },

  stringTimeToSeconds: str => {
    const tArray = str.split( ':').map( t => parseFloat( t)).slice(0,3);
    const timeArray = Array.from( Array( 3 - tArray.length), () => 0).concat( tArray);
    return timeArray[0] * 60 * 60 + timeArray[1] * 60 + timeArray[2];
  },
  
  parseVtt: text => {   // TODO REVIEW usar parser estandar vtt
    const timeElements = [];
    text.split( /\n\s*\n/).forEach( tag => {
      tag = tag.split( '\n');
      while( tag.length >= 2 && !/^[\s0-9:.]+-->[\s0-9:.]+$/.exec( tag[0])) tag = tag.slice(1);
      if( tag.length >= 2) {
        timeElements.push( {
          begin: Tagging.stringTimeToSeconds( tag[0].split( '-->')[0]),
          end: Tagging.stringTimeToSeconds( tag[0].split( '-->')[1]),
          text: tag.slice(1).join( '<br>'),
        });
      }
    });
    return timeElements;
  },

  loadTranscription: async taggingConfiguration => {
    const { taggingList, chaptersUrl } = taggingConfiguration;
    const getText = url => Call.get( url, {}, { parseResponse: true });

    const promises = [];
    const taggings = {};
    taggingList.forEach( taggingFile => {
      promises.push(
        getText( taggingFile.url).then( text => ({
          label: taggingFile.label,
          tagging: Tagging.parseVtt( text),
        }))
      );
    });
    const transcriptions = await Promise.all( promises);
    transcriptions.forEach( transcription => {
      taggings[ transcription.label] = transcription.tagging;
    });

    const chapters = chaptersUrl ? Tagging.parseVtt( await getText( chaptersUrl)) : [];
    return { taggings, chapters };
  },
  
};

export default Tagging;
